import { render } from "./SocialMidiaList.vue?vue&type=template&id=041f7e86"
import script from "./SocialMidiaList.vue?vue&type=script&lang=js"
export * from "./SocialMidiaList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__